import React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import {Checkbox, useTheme} from "@mui/material";
import {formatTimestampWithDOWDetailed} from "../../utils";
import Button from "@mui/material/Button";

export const AuditLogGrid = ({rows, selectedAuditRecords, rolledBackRecords, onSelectCheckboxClick, fromIdSetter, toIdSetter}) => {
    const theme = useTheme();
    const indicators = theme.palette.indicator;
    const buttonBorder = theme.palette.contentPanel.border;

    const renderTradeCheckbox = (params) => {
        //TODO: DataGrid column def could have checkboxSelection property...?
        const handleChange = async (event) => {
            onSelectCheckboxClick(params.row, event.target.checked);
        }
        return (
            <Checkbox checked={selectedAuditRecords.includes(params.row.event_id)} onChange={handleChange} style={{padding: 0, paddingTop: 7}}/>
        )
    };

    const renderEventId = (params) => {
        const rolledBack = Object.keys(rolledBackRecords).includes(params.value);
        const color = rolledBack ? indicators.green : 'inherit';
        return (
            <div style={{paddingTop: 5}}>
                <span style={{color: color, fontWeight: 'bold'}}>{params.value}</span>
                <Button style={{marginTop: 5, padding: 0, border: buttonBorder}} onClick={() => fromIdSetter(params.value)}>FROM</Button>
                <Button style={{marginTop: 5, padding: 0, border: buttonBorder}} onClick={() => toIdSetter(params.value)}>TO</Button>
                {rolledBack &&
                    <div>
                        <br/>
                        <span>ROLLED BACK</span>
                    </div>
                }
            </div>
        );
    };

    const renderTimestampCell = (params) => {
        return (
            <div style={{paddingTop: 5}}>
                <span style={{fontWeight: 'bold'}}>{formatTimestampWithDOWDetailed(params.value)}</span>
                <br/>
                <span>({params.value})</span>
            </div>
        );
    };

    const renderAction = (params) => {
        const cellText = params.row.action === 'I' ? 'INSERT' : params.row.action === 'U' ? 'UPDATE' : params.row.action === 'D' ? 'DELETE' : '';
        const color = params.row.action === 'I' ? indicators.green : params.row.action === 'U' ? indicators.orange : params.row.action === 'D' ? indicators.red : '';
        return (
            <div style={{paddingTop: 7}}>
                <span style={{backgroundColor: color, color: 'white', padding: 2, paddingLeft: 4, paddingRight: 4}}>{cellText}</span>
                <br/>
                <span style={{fontWeight: 'bold'}}>{params.row.table_name}</span>
            </div>
        );
    };

    const renderQueryCell = (params) => {
        return <pre style={{fontSize: 11, whiteSpace: 'normal', wordBreak: 'break-word'}}>{params.value}</pre>;
    };

    const renderCombinedCell = (params) => {
        const uppercaseBooleans = (v) => {
            if (v === 't') return 'TRUE';
            else if (v === 'f') return 'FALSE';
            else return v;
        };
        return (
            <table style={{fontSize: 12, width: '100%', marginTop: 10, marginBottom: 15, borderCollapse: 'collapse'}}>
                <tbody>
                {params.row.row_data && Object.keys(params.row.row_data).map((key, index) => {
                    const isChanged = !!(params.row.changed_fields && Object.keys(params.row.changed_fields).includes(key));
                    const rowClass = isChanged ? 'changed' : '';
                    return (
                        <tr key={index} className={rowClass}>
                            <td style={{border: 'thin black solid', paddingLeft: 5, fontWeight: isChanged ? 'bold' : 'inherit'}}>{key}</td>
                            <td style={{border: 'thin black solid', paddingLeft: 5}}>{uppercaseBooleans(params.row.row_data[key])}</td>
                            {params.row.action === 'U' && (
                                <td style={{border: 'thin black solid', paddingLeft: 5}}>{uppercaseBooleans(params.row.changed_fields ? params.row.changed_fields[key] : null)}</td>
                            )}
                        </tr>
                    )
                })}
                </tbody>
            </table>
        );
    };

    const common = {sortable: true, disableColumnMenu: false, headerClassName: 'grid-header'};
    const colDefs = [
        {...common, width: 50, headerName: ' ', field: 'select', align: 'center', renderCell: renderTradeCheckbox},
        {...common, width: 80, headerName: 'Event ID', field: 'event_id', align: 'center', renderCell: renderEventId},
        {...common, width: 205, headerName: 'Timestamp', field: 'action_tstamp_tx', renderCell: renderTimestampCell},
        {...common, width: 175, headerName: 'Action', field: 'action', renderCell: renderAction},
        {...common, width: 300, headerName: 'Query', field: 'client_query', renderCell: renderQueryCell},
        {...common, width: 630, headerName: 'Changes', field: 'row_data', renderCell: renderCombinedCell}
    ];

    const calcWidth = (cols) => {
        return cols.reduce((t, c) => t + c.width, 0) + 2;
    };

    const determineRowClass = (params) => {
        return `${params.indexRelativeToCurrentPage % 2 === 1 ? 'table-row-odd' : 'table-row-even'}`
    };

    return (
        <div style={{width: calcWidth(colDefs)}}>
            <DataGrid columns={colDefs} rows={rows} pageSizeOptions={[25, 50, 100]}
                      initialState={{pagination: {paginationModel: {pageSize: 50, page: 0}}}}
                      columnHeaderHeight={30} getRowHeight={() => 'auto'}
                      getRowClassName={(params) => (determineRowClass(params))}
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
}
